// extracted by mini-css-extract-plugin
module.exports = {"container":"tl","slide":"tm","show":"tn"};